import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import Proctor from '../components/Proctor/Proctor';
import {
  enableWebcam,
  allowWebcamPermission,
  enableSnapshotInterval,
  disableSnapshotInterval,
  allowAudioPermission,
  audioPermissionLoading,
  denyAudioPermission,
  webcamPermissionLoading,
  denyWebcamPermission,
} from '../actions/proctor';
import { setFingerPrint, trackChangeRoute } from '../actions/eventTracking';

const mapStateToProps = state => {
  return {
    test: state.test,
    testSolutionSet: state.testSolutionSet,
    webcamEnabled: state.proctor.webcamEnabled,
    snapshotInterval: state.proctor.snapshotInterval,
    socketActive: state.socket.socketActive,
    fingerprint: state.socket.fingerprint,
    auth: state.auth,
  };
};

const mapDispatchToProps = dispatch => {
  return bindActionCreators(
    {
      enableWebcam,
      allowWebcamPermission,
      allowAudioPermission,
      audioPermissionLoading,
      denyAudioPermission,
      webcamPermissionLoading,
      denyWebcamPermission,
      enableSnapshotInterval,
      disableSnapshotInterval,
      setFingerPrint,
      trackChangeRoute,
    },
    dispatch
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(Proctor);
